// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"845":"3493fd9deee75bdff0df","944":"c951a3f1d1c81e35c471"}[chunkId] + ".js";
};